import React from 'react';

import { Stack } from '@mui/material';

import LanguageSwitcher from '../LanguageSwitcher';
import Menu from './components/Menu';
import User from './components/User';
import { Drawer } from './styles';

const Sidebar = React.memo(() => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOpen = React.useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <Drawer variant="permanent" open={isOpen} width={246} onClick={handleOpen}>
      <Stack spacing={1.5}>
        <User isCompact={!isOpen} />
        <Menu />
      </Stack>

      <LanguageSwitcher showLabel={isOpen} />
    </Drawer>
  );
});

export default Sidebar;
